// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";
import store from './src/store/index.js'

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/database";
import "firebase/functions";
const firebaseConfig = {
    apiKey: process.env.VUE_APP_FIRE_API_KEY,
    authDomain: process.env.VUE_APP_FIRE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIRE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIRE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIRE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIRE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIRE_APP_ID,
    measurementId: process.env.VUE_APP_FIRE_MEASUREMENT_ID
  };
firebase.initializeApp(firebaseConfig);
export const db =  firebase.database()
export const auth =  firebase.auth()
export const analytics =  firebase.analytics()
export const functions =  firebase.functions()
firebase.getCurrentUser = () => {
    return new Promise((resolve, reject) => {
        const unsubscribe = firebase.auth().onAuthStateChanged(user => {
            unsubscribe();
            store.commit('setUser',user);
            resolve(user);
        }, reject);
    })
};
